"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AccountMan_1 = __importDefault(require("@kawaui/icons/build/icons/action/AccountMan"));
const Apps_1 = __importDefault(require("@kawaui/icons/build/icons/action/Apps"));
const Disconnection_1 = __importDefault(require("@kawaui/icons/build/icons/action/Disconnection"));
const Gift_1 = __importDefault(require("@kawaui/icons/build/icons/action/Gift"));
const Help_1 = __importDefault(require("@kawaui/icons/build/icons/action/Help"));
const Home_1 = __importDefault(require("@kawaui/icons/build/icons/action/Home"));
const Info_1 = __importDefault(require("@kawaui/icons/build/icons/action/Info"));
const Orders_1 = __importDefault(require("@kawaui/icons/build/icons/action/Orders"));
const Settings_1 = __importDefault(require("@kawaui/icons/build/icons/action/Settings"));
const ContactUs_1 = __importDefault(require("@kawaui/icons/build/icons/informative/ContactUs"));
const NewsVp_1 = __importDefault(require("@kawaui/icons/build/icons/informative/NewsVp"));
const Cross_1 = __importDefault(require("@kawaui/icons/build/icons/navigation/Cross"));
const SponsorshipEuro_1 = __importDefault(require("@kawaui/icons/build/icons/sponsorship/SponsorshipEuro"));
const SponsorshipLivre_1 = __importDefault(require("@kawaui/icons/build/icons/sponsorship/SponsorshipLivre"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = require("styled-components");
const constants_1 = require("../../constants");
const useHomepage_1 = __importDefault(require("../../hooks/useHomepage"));
const useTracking_1 = __importDefault(require("../../hooks/useTracking"));
const styles_1 = require("../homes/styles");
const link_1 = __importDefault(require("../link"));
const loginBtn_1 = __importDefault(require("../loginBtn"));
const menuButton_1 = __importDefault(require("../menuButton"));
const accessibility_1 = __importDefault(require("./accessibility"));
const countryList_1 = __importDefault(require("./countryList"));
const Styled = __importStar(require("./styles"));
const subMenu_1 = __importDefault(require("./subMenu"));
const getIcon = (key) => {
    switch (key) {
        case 'nav_acc':
            return AccountMan_1.default;
        case 'nav_alert':
            return Settings_1.default;
        case 'nav_le_club':
            return ContactUs_1.default;
        case 'nav_cmd':
            return Orders_1.default;
        case 'nav_forum':
            return ContactUs_1.default;
        case 'nav_hlp':
            return Help_1.default;
        case 'nav_hme':
            return Home_1.default;
        case 'nav_kdo':
            return Gift_1.default;
        case 'nav_mob':
            return Apps_1.default;
        case 'nav_new':
            return NewsVp_1.default;
        case 'nav_off':
            return Disconnection_1.default;
        case 'nav_information':
            return Info_1.default;
        case 'nav_spn':
            return SponsorshipEuro_1.default;
        case 'nav_spn_uk':
            return SponsorshipLivre_1.default;
        default:
            return null;
    }
};
const cleanSessionStorage = () => {
    delete sessionStorage.veepeeMember;
};
const LateralMenu = ({ isOpenDoor, loginElement, loginText, menu }) => {
    const theme = (0, styled_components_1.useTheme)();
    const { generateLateralMenuHitConfig } = (0, useTracking_1.default)();
    const { highlighted } = (0, useHomepage_1.default)();
    const [isMobile, setIsMobile] = (0, react_1.useState)(false);
    const [canClose] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isSubMenuOpen, setIsSubMenuOpen] = (0, react_1.useState)(false);
    const [subMenuItems, setSubMenuItems] = (0, react_1.useState)([]);
    const [subMenuTitle, setSubMenuTitle] = (0, react_1.useState)('');
    const [bodyStyle, setBodyStyle] = (0, react_1.useState)({ overflow: '', paddingRight: '' });
    const [bodyScroll, setBodyScroll] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined')
            return;
        const handler = () => {
            setIsMobile(window.innerWidth < parseInt(theme.breakpoint.desktop, 10));
        };
        setIsMobile(window.innerWidth < parseInt(theme.breakpoint.desktop, 10));
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, [setIsMobile]);
    (0, react_1.useEffect)(() => {
        if (!isMobile)
            setIsSubMenuOpen(false);
    }, [isMobile]);
    (0, react_1.useEffect)(() => {
        if (isMobile && isOpen && document) {
            enableBodyLock();
        }
        else if (isMobile && !isOpen && document) {
            disableBodyLock();
        }
    }, [isMobile, isOpen]);
    const enableBodyLock = () => {
        setBodyStyle({ overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight });
        setBodyScroll(window.pageYOffset);
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '0px';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.pageYOffset}px`;
        document.body.style.width = '100%';
    };
    const disableBodyLock = () => {
        document.body.style.overflow = (bodyStyle && bodyStyle.overflow) || 'auto';
        document.body.style.paddingRight = (bodyStyle && bodyStyle.paddingRight) || '0px';
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');
        setBodyStyle({ overflow: '', paddingRight: '' });
        window.scrollTo(0, bodyScroll);
    };
    const closeMenu = (0, react_1.useCallback)(() => {
        if (canClose)
            setIsOpen(true);
    }, [canClose]);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        if (!isMobile)
            setIsOpen(true);
    }, [isMobile]);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        if (!isMobile)
            setIsOpen(false);
    }, [isMobile]);
    const renderListItem = (item, index) => {
        if (isOpenDoor && item.loggedIn)
            return null;
        const Icon = getIcon(item.cssClass);
        const onClick = () => {
            if (item.cssClass === 'nav_off') {
                cleanSessionStorage();
                return;
            }
        };
        return ((0, jsx_runtime_1.jsx)(Styled.ListItem, { children: (0, jsx_runtime_1.jsxs)(link_1.default, { href: item.defaultUrl, variant: "tertiary", forcedExternal: !isOpenDoor, onClick: onClick, hitConfig: generateLateralMenuHitConfig((highlighted === null || highlighted === void 0 ? void 0 : highlighted.displayName) || '', item.cssClass), children: [Icon && (0, jsx_runtime_1.jsx)(Icon, { height: "28px", width: "28px" }), (0, jsx_runtime_1.jsx)("span", { children: item.text }), item.upperDisplayName && ((0, jsx_runtime_1.jsx)(styles_1.NavItemSup, { isSelected: false, isPrimary: true, children: item.upperDisplayName }))] }) }, `${index}_${item.defaultUrl}`));
    };
    const renderBottomListItems = (section, index) => {
        const onClick = (text, subItems) => {
            if (subItems) {
                setSubMenuItems(subItems);
                setIsSubMenuOpen(true);
                setSubMenuTitle(text);
            }
        };
        return ((0, jsx_runtime_1.jsx)(Styled.LegalListItem, { children: (0, jsx_runtime_1.jsx)(link_1.default, { href: section.defaultUrl, variant: "tertiary", forcedExternal: true, onClick: () => onClick(section.text, section.lateralMenuSubSections), children: section.text }) }, `${index}_${section.defaultUrl}`));
    };
    const handleClick = () => {
        setIsOpen(menu.isActive && !isOpen);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.MenuOverlay, { isOpen: isOpen, onTouchStart: closeMenu }), (0, jsx_runtime_1.jsxs)(Styled.MenuContainer, { onMouseLeave: handleMouseLeave, onMouseEnter: handleMouseEnter, "data-facil-iti": "header-menu", "data-testid": "header-menu", children: [(0, jsx_runtime_1.jsx)(menuButton_1.default, { isOpen: isOpen, onClick: handleClick }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 200, mountOnEnter: true, unmountOnExit: true, classNames: "header--menu", "data-facil-iti": "header-menu-button", children: (0, jsx_runtime_1.jsxs)(Styled.StyledContent, { "data-facil-iti": "header-menu-items", children: [(0, jsx_runtime_1.jsx)(Styled.MenuCloseWrapper, { onClick: handleClick, children: (0, jsx_runtime_1.jsx)(Cross_1.default, {}) }), loginElement && ((0, jsx_runtime_1.jsx)(Styled.List, { children: (0, jsx_runtime_1.jsx)(Styled.ListItem, { children: (0, jsx_runtime_1.jsx)(loginBtn_1.default, { loginElement: loginElement, isTransparent: false, text: loginText, tracking: { position: constants_1.LoginButtonPosition.HEADER_MENU } }) }) })), menu &&
                                    menu.links &&
                                    menu.links.map((subMenu, i) => ((0, jsx_runtime_1.jsx)(Styled.List, { children: subMenu.sections.map((item, index) => renderListItem(item, index)) }, i))), isMobile && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Styled.LegalContent, { children: [menu.lateralMenuBottomSections && ((0, jsx_runtime_1.jsx)(Styled.LegalList, { children: menu.lateralMenuBottomSections.map((bottomSections) => bottomSections.sections.map((section, index) => renderBottomListItems(section, index))) })), menu.faciliti.logo && menu.faciliti.text && ((0, jsx_runtime_1.jsx)(accessibility_1.default, { logo: menu.faciliti.logo, text: menu.faciliti.text, handleClose: () => setIsOpen(false) })), menu.countryBlock && (0, jsx_runtime_1.jsx)(countryList_1.default, Object.assign({}, menu.countryBlock))] }) }))] }) }), (0, jsx_runtime_1.jsx)(subMenu_1.default, { isOpen: isSubMenuOpen, handleClose: () => setIsSubMenuOpen(false), items: subMenuItems, title: subMenuTitle })] })] }));
};
exports.default = LateralMenu;
